class Api {
  levelId = {};
  isStandAlone = null;

  constructor(auth) {
    this.levelId = {
      realm: auth.realm?.id,
      org: auth.orgs?.id,
    };
    this.isStandAlone = this._checkStandAlone();

    Api.instance = this;
  }

  static init(auth) {
    Api.instance = null;
    return new Api(auth);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  };

  getRequestParams() {
    const params = this.isStandAlone
      ? { orgId: this.levelId.realm }
      : {
          entId: this.levelId.realm,
          orgId: this.levelId.org,
        };
    
    const apiKey = this.isStandAlone
      ? "/orgs/:orgId/license/add.create"
      : "/ents/:entId/orgs/:orgId/license/add.create";

    return {
      apiKey,
      params,
    };
  }
}

export default Api;
